// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"home-module--imgContainer--39HND","image":"home-module--image--2ZmjY","desktopImage":"home-module--desktopImage--36GoY"};